import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Economics = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.183 7.67H.902C.4 7.67 0 8.07 0 8.572v26.851c0 .501.4.902.902.902h42.18c.502 0 .902-.4.902-.902V8.572c.1-.501-.3-.902-.801-.902ZM1.903 9.473h5.812a5.815 5.815 0 0 1-5.811 5.812V9.473Zm0 25.049V28.71a5.815 5.815 0 0 1 5.812 5.812H1.904Zm40.278 0H36.37a5.815 5.815 0 0 1 5.811-5.812v5.812Zm0-7.715c-4.208 0-7.715 3.506-7.715 7.715H9.618c0-4.209-3.506-7.615-7.714-7.715v-9.619c4.208 0 7.614-3.506 7.714-7.715h24.848c0 4.208 3.507 7.615 7.715 7.715v9.619Zm0-11.522a5.815 5.815 0 0 1-5.811-5.812h5.811v5.812Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.65 22.198c-.802-.501-1.804-.802-2.706-1.002v-5.911c.601.1 1.102.4 1.603.7.701.502 1.102 1.203 1.102 2.105 0 .5.401.902.902.902s.902-.401.902-.902c0-1.503-.802-2.805-1.904-3.607-.801-.601-1.803-1.002-2.705-1.202v-1.102c0-.501-.4-.902-.902-.902-.5 0-.902.4-.902.902v1.102c-2.504.4-4.608 2.204-4.608 4.709 0 .801.2 1.503.5 2.204.301.601.802 1.102 1.403 1.403.802.5 1.804.801 2.705 1.002v5.911c-1.703-.3-2.705-1.603-2.705-2.805 0-.501-.4-.902-.902-.902-.5 0-.901.4-.901.902 0 2.504 2.104 4.308 4.609 4.709v1.102c0 .5.4.901.901.901s.902-.4.902-.901v-1.102c2.505-.401 4.609-2.205 4.609-4.71 0-.801-.2-1.502-.501-2.204-.3-.5-.802-.901-1.403-1.302Zm-4.51-1.403c-.7-.2-1.302-.4-1.703-.701-.3-.2-.6-.401-.701-.702-.2-.3-.3-.7-.3-1.202 0-1.202 1.102-2.505 2.705-2.805v5.41Zm1.804 7.915V23.2c.701.2 1.202.4 1.703.701.301.2.602.4.702.701.2.301.3.702.3 1.303 0 1.202-1.002 2.405-2.705 2.805Z"
  }));
});
Economics.displayName = 'Economics';
Economics.defaultProps = {
  'aria-label': 'Economics'
};
export default Economics;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Economics.js
// module id = 3006
// module chunks = 11